import { render, staticRenderFns } from "./GroupSideNav.vue?vue&type=template&id=1e54100c"
import script from "./GroupSideNav.vue?vue&type=script&lang=js"
export * from "./GroupSideNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports